import React, {Fragment} from "react";

// components
import NestedTable from "../../../../Common/Legacy/NestedTable";

import ThirdLevel from "./ThirdLevel";
import {toFixedDate, toStackedBarChart} from "../../../../../utils/reactFunctions";
import {CompositeFilterDescriptor} from "@progress/kendo-data-query";

interface Props {
  dataItem: any;
  activeFilters: CompositeFilterDescriptor;
  featuresAllowed: string[];
}

export default (props: Props) => {
  // grilla por fecha debe mostrar Fecha, y la barra de proporcion para esa fecha, cantidad total de clientes
  const tableConfig = (firstColumnName: string) => {
    return [
      {
        headTitle: firstColumnName,
        rowValue: "date",
        custom: toFixedDate,
      },
      {
        headTitle: 'FUENTES',
        rowValue: "sourcePercentages",
        custom: toStackedBarChart,
      },
      {
        headTitle: 'CLIENTES TOTALES',
        rowValue: "totalClients",
      },
    ];
  };

  return (
    <Fragment>
      <NestedTable
        tableConfig={tableConfig('FECHA')}
        tableData={props.dataItem.sellerStatsByDates}
        loading={false}
        detailComponent={
          (detailProps) =>
              ThirdLevel({
                detailProps, 
                sellerId: props.dataItem.sellerId, 
                activeFilters: props.activeFilters, 
                featuresAllowed:props.featuresAllowed
              })
        }
        featuresAllowed={props.featuresAllowed}
      />
    </Fragment>
  );
};
